/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ModelOnboardingMoveRequest,
  ModelOnboardingResponse,
  ModelOnboardingStartRequest,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Onboarding<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * @description onboarding workflow move for/backward
   *
   * @tags onboarding
   * @name WorkflowMoveCreate
   * @summary onboarding workflow move for/backward
   * @request POST:/onboarding/workflow/move
   */
  workflowMoveCreate = (
    request: ModelOnboardingMoveRequest,
    params: RequestParams = {}
  ) =>
    this.request<ModelOnboardingResponse, any>({
      path: `/onboarding/workflow/move`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description start onboarding workflow
   *
   * @tags onboarding
   * @name WorkflowStartCreate
   * @summary start onboarding workflow
   * @request POST:/onboarding/workflow/start
   */
  workflowStartCreate = (
    request: ModelOnboardingStartRequest,
    params: RequestParams = {}
  ) =>
    this.request<ModelOnboardingResponse, any>({
      path: `/onboarding/workflow/start`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
